import { Injectable } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import { CaeData } from './cae-data.service';
import { HttpErrorResponse } from '@angular/common/http';
import { WagoApiClient } from '@shared/service/wago-api.client';
import { NumberUtils } from '@shared/util/number-utils';
import { AlertHelper } from '@shared/alert/alert.helper';
import { StringUtils } from '@shared/util/string-utils';
import { WagoApiStatusCode } from '@shared/service/wago-api-status-code';

@Injectable({
  providedIn: 'root'
})
export class CaeService {

  constructor(
    private alertHelper: AlertHelper,
  ) { }

  public async validateProjectWithErrorHandling(caeDataObservable: Observable<CaeData>): Promise<CaeData | undefined> {
    try {
      const caeData = await lastValueFrom(caeDataObservable);
      this.validateProject(caeData);
      return caeData;
    } catch(error) {
      const httpResponse = error as HttpErrorResponse;
      let errorMessage: string;
      const faultString: string = httpResponse.message;
      const statusCode: number = WagoApiClient.getErrorStatusCode(httpResponse);
      if (NumberUtils.isNumber(statusCode) && WagoApiStatusCode.Forbidden === statusCode) {
        errorMessage = 'serverCommunication.message.user_has_no_rights';
      } else if (faultString.indexOf('java.io.IOException: Invalid storage id.') !== -1) {
        errorMessage = 'importProject.message.import_failed_due_to_invalid_link';
      } else if (faultString.indexOf('java.io.IOException: cae_project_import_error') !== -1) {
        errorMessage = 'importProject.message.import_failed_due_to_invalid_location';
      } else if (httpResponse.error.error === 'CaeValidationException') {
        errorMessage = 'cae.import.validationException';
      } else {
        errorMessage = 'importProject.message.import_failed';
      }
      await this.alertHelper.showError('importProject.title.import_failed', errorMessage);
    }
  }

  private validateProject(data: CaeData) {
    const ids: string[] = [];

    for (const rail of data.project.rails) {
      this.validateItem(rail, ids);

      for (const item of rail.items) {
        this.validateItem(item, ids);

        for (const accessory of item.items) {
          this.validateItem(accessory, ids);
        }
      }

      for (const bridge of rail.bridges) {
        this.validateItem(bridge, ids);
      }

      for (const accessory of rail.accessory) {
        this.validateItem(accessory, ids);
      }
    }
  }

  private validateItem(item: { id: string }, ids: string[]) {
    const id = item.id;
    if (!id) {
      item.id = StringUtils.createUuid();
    } else if (ids.includes(id)) {
      item.id = id + '_' + StringUtils.createUuid();
    }
    ids.push(id);
  }
}
